// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    BRANDS_OVERVIEW_GET_DATA_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    brandgetDataResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getBrand({ payload }) {
    try {
        let QUERY_BRAND = `
            query getBrand ($id: Int!) {
                result: getBrand (id: $id) {
                    id
                    code
                    title
                    domains
                    createdBy
                    createdOn
                    updatedBy
                    updatedOn
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY_BRAND,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(brandgetDataResult({ data: data.result }));
        } else {
            yield put(brandgetDataResult({ data: null }));
        }

    } catch (exc) {
        yield put(brandgetDataResult({ error: true }));
    }
}


function* watchMethods() {
    yield takeEvery(BRANDS_OVERVIEW_GET_DATA_REQUEST, getBrand);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}